import { EnumFeedType } from "src/api/server/feed.types";

export const feedKeys = {
    all: ["feed"] as const,
    user: (feedType?: EnumFeedType) => (feedType ? (["feed", "user", feedType] as const) : (["feed", "user"] as const)),
    wikifolio: (wikifolioId: string) => ["feed", "wikifolio", wikifolioId] as const,
    pinnedComment: (wikifolioId: string) => ["feed", "pinned-comment", wikifolioId] as const,
    v4: (feedName: string, feedType?: EnumFeedType, userId?: string, underlyingIsins?: string[], wikifolioIds?: string[]) =>
        ["feed", "v4", feedName, feedType, userId, JSON.stringify(underlyingIsins), JSON.stringify(wikifolioIds)] as const,
    news: {
        all: ["feed", "news"] as const,
        allNews: ["feed", "news", "all"] as const,
        trending: ["feed", "news", "trending"] as const,
        wikifolio: (wikifolioId: string) => ["feed", "news", "wikifolio", wikifolioId] as const,
        randomTrending: ["feed", "news", "random-trending"] as const,
    },
} as const;
